module.exports = __webpack_public_path__ + "static/media/info.5865fa4e.svg";